import React, { useEffect, useState } from 'react'
import styles from './style.module.css'
import { getQuery, setEvent } from '@/core/utile'
import { isWechat } from '@weike/toolkit'
import { Toast } from 'antd-mobile'
import 'antd-mobile/lib/toast/style/css'

declare const wx: any

const { form = '', app_type = 'lihua', scene = 'webview' } = getQuery()
const isInWechat = isWechat()

// 各 app 类型对应的本地配置
const APP_CONFIG: Record<
  string,
  { appId: string; logoUrl: string; downloadUrl: string; scheme: string }
> = {
  lihuaedu: {
    appId: 'wxe5facdcdf8c481d3',
    logoUrl: 'https://img.lycheer.net/xupload/519/6911c3fafa2c11dc83d2974c.png',
    downloadUrl:
      'https://a.app.qq.com/o/simple.jsp?pkgname=com.lizhiweike.lihuaedu',
    scheme: 'lihuaedu',
  },
  lihua: {
    appId: 'wxb14e61b3b90605ad',
    logoUrl: 'https://img.lycheer.net/xupload/446/69dde9752ae24854a7ff1609.png',
    downloadUrl:
      'https://a.app.qq.com/o/simple.jsp?pkgname=com.lizhiweike.lihua',
    scheme: 'lihua',
  },
}

const currentAppConfig = APP_CONFIG[app_type] || APP_CONFIG['lihua']

// 统一的样式配置对象
const launchStyleConfig: React.CSSProperties = {
  fontSize: '18px',
  color: '#ffffff',
  lineHeight: '50px',
  width: '174px',
  height: '50px',
  background: 'linear-gradient(135deg, rgb(138 99 220), rgb(130 87 217) 100%)',
  borderRadius: '25px',
  textAlign: 'center',
  margin: '0 auto',
  marginTop: '50px',
}

// 工具函数：将样式对象转换为 CSS 字符串
const styleToCssString = (styleObj: React.CSSProperties) => {
  return Object.entries(styleObj)
    .map(([key, value]) => {
      const cssKey = key.replace(/[A-Z]/g, m => '-' + m.toLowerCase())
      return `${cssKey}: ${value};`
    })
    .join('')
}

// 工具函数：生成内联样式标签
const generateInlineStyle = (
  styleObj: React.CSSProperties,
  className = 'launch-btn',
) => {
  const cssString = styleToCssString(styleObj)
  return `<style>.${className} { ${cssString} }</style>`
}

// 预生成需要的样式
const inlineStyle = generateInlineStyle(launchStyleConfig)
const launchStyleObj = launchStyleConfig

const LaunchApp = () => {
  const { appId, logoUrl, downloadUrl, scheme } = currentAppConfig
  const [isWxReady, setIsWxReady] = useState(false)

  useEffect(() => {
    if (wx) {
      wx.ready(() => {
        setIsWxReady(true)
        console.log('微信初始化成功')
      })
    } else {
      console.warn('微信sdk初始化失败')
      setIsWxReady(true)
    }
  }, [])

  useEffect(() => {
    if (isWxReady) {
      const launchBtn = document.getElementById('wx-launch-app-btn')
      if (launchBtn) {
        // 打开app成功或者取消打开app走的这个回调
        const handleLaunch = () => {
          setEvent('ra_launch_edu_app', { status: 'success' })
        }
        const handleError = () => {
          Toast.info(`未安装app，正在跳转下载页`)
          setEvent('ra_launch_edu_app', { status: 'fail' })
          setTimeout(() => {
            window.location.href = downloadUrl
          }, 2000)
        }

        launchBtn.addEventListener('launch', handleLaunch)
        launchBtn.addEventListener('error', handleError)

        return () => {
          launchBtn.removeEventListener('launch', handleLaunch)
          launchBtn.removeEventListener('error', handleError)
        }
      }
    }
  }, [isWxReady, downloadUrl])

  const launchApp = () => {
    // 打开梨花研修院app
    window.location.href = `${scheme}://${scene}${window.location.search}`
  }

  return (
    <div className={styles.launch_app}>
      <img className={styles.launch_app_img} src={logoUrl} alt="" />
      {isInWechat ? (
        <div
          dangerouslySetInnerHTML={{
            __html: `
            <wx-open-launch-app
                id="wx-launch-app-btn"
                style="width: 100vw;"
                appid="${appId}"
                extinfo='{"type":"router", "url": "${`${scheme}://${scene}${window.location.search}`}", "form": "${form}"}'
            >
              <script type="text/wxtag-template">
                ${inlineStyle}
                <style>
                  .launch-btn:active {
                    background: linear-gradient(135deg, #e6724c, #d43a22 100%);
                  }
                </style>
                <div class="launch-btn">前往APP学习</div>
              </script>
            </wx-open-launch-app>
        `,
          }}
        />
      ) : (
        <div style={launchStyleObj} onClick={launchApp}>
          前往APP学习
        </div>
      )}
    </div>
  )
}
export default LaunchApp
